let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("fLQqZ")).then(() => parcelRequire('8vJyT'));